// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--fixed-hero-cards-margin: 10px;--hero-cards-image-size: 62px;--hero-cards-padding: 32px}@media(min-width: 1280px){:root{--hero-cards-image-size: 92px}}", ""]);
// Exports
module.exports = exports;
